import React from 'react';
import classNames from 'classnames';

import ExternalLink from 'src/components/common/external-link';

import { LOCALES } from 'src/constants';
import type { PageHeadingProps } from './page-heading.props';

import './page-heading.scss';

const PageHeading = ({
  decedent,
  description,
  isHideDecedentOnDesktop,
  step,
  title,
}: PageHeadingProps) => {
  const shouldShowDecedentLink = !!decedent?.name && !!decedent.link;
  const headingContentClasses = classNames('page-heading__content', {
    'page-heading__content_hide-decedent': !shouldShowDecedentLink,
    'page-heading__content_hide-decedent-desktop': isHideDecedentOnDesktop,
  });

  return (
    <div className="page-heading">
      <h1 className="page-heading__title">{title}</h1>
      <div className={headingContentClasses}>
        {shouldShowDecedentLink && (
          <ExternalLink
            className="page-heading__decedent"
            href={decedent.link}
            title={LOCALES.BACK_TO_RECORD_PAGE}
          >
            {decedent.name}
          </ExternalLink>
        )}
        <span className="page-heading__steps">
          {LOCALES.STEP_OF_3.replace('{X}', step.toString())}
        </span>
      </div>
      {description && <p className="page-heading__info">{description}</p>}
    </div>
  );
};

export default PageHeading;
